/**
 * 
 * key
 * 
 */


const key = 'ZnJlZWxhbmNlclF0eUxpc3Q='

export default key 